import { React, UseState, UseEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PageContent from 'layouts/PageContent';
import SalesByLocationDash from './SalesByLocationDash';

const SalesByLocationScreen = (props) => {
  const {t, i18n} = useTranslation(['salesPerformance', 'common']);
  
  return (
    <PageContent title={t('salesPerformance:SalesByLocation')}>
      <SalesByLocationDash />
    </PageContent>
  )
}

export default SalesByLocationScreen;